<script>
import ExpandableText from '@/system/components/global/ExpandableText';
import OnlineBookingLocaleSelector from '@/online_booking/new/components/OnlineBookingLocaleSelector';
import ClientsSelectNew from '@/system/components/global/form/ClientsSelectNew';
import TimezoneSelector from '@/system/components/login/TimezoneSelector';
import Card from '@/online_booking/new/components/common/Card';
import UnsplashModal from '@/system/components/global/unsplash/UnsplashModal';
import DynamicIsland from '@/online_booking/new/components/header/DynamicIsland';
import swal from 'sweetalert';
import { http } from '@/system/http';
import dayjs from 'dayjs';
import Color from 'tinycolor2';
import { mapGetters } from 'vuex';
import currentRoute from '@/online_booking/new/mixins/currentRoute';
import { setUserId, setClientId } from '@/system/helpers/newRelic';

export default {
    components: {
        ExpandableText,
        OnlineBookingLocaleSelector,
        ClientsSelectNew,
        TimezoneSelector,
        Card,
        UnsplashModal,
        DynamicIsland,
    },

    watch:{
        $route (to, from) {
            this.setIsEventContext(this.$route.name);
            this.setIsOnlineCourseContext(this.$route.name);
            this.setIsMembershipsContext(this.$route.name);
            this.sendGAPageView(to);
            this.showMobileMenu = false;
        }
    },

    data() {
        return {
            loggedIn: logged_in,
            loading: false,
            permalink: permalink,
            is_event_context: false,
            is_online_course_context: false,
            is_memberships_context: false,
            course_purchases: [],
            showTimezoneOffset: false,
            showMobileMenu: false,
            themeColor: window.theme_color,
            isInsideIframe: window.self !== window.top,
            hideNavigationMenu: false,
        }
    },

    created() {
        this.generateTheme();
    },

    mounted: function(){
        var vm = this;

        // Load countries so that it becomes available in every online booking subpage form
        this.$store.dispatch('countries/getCountries')

        vm.$nextTick(function() {
            swal.setDefaults({ animation: 'pop' });
        });

        this.$event_bus.$on('LoggedIn', (data) => {
            vm.setupLoggedInClient(data);
        });

        this.$event_bus.$on('LoadData', (data) => {
            this.$store.commit('setUser', data.user);
            vm.setupLoggedInClient(data);
        });

        this.$event_bus.$on('LoadEventData', (data) => {
            vm.setupLoggedInClient(data);
        });

        this.setIsEventContext(this.$route.name);
        this.setIsOnlineCourseContext(this.$route.name);

        if (document.referrer.indexOf('cookied_fixed') >= 0) {
            // cookie fixed, show the login form again
            vm.$router.push('/book/' + vm.permalink + '/center');
        }

        //Determine if we must allow displaying the Timezone Offset
        if (this.getClientTimezoneOffset() !== this.getPracticeTimezoneOffset()) {
            this.showTimezoneOffset = true;
        }

        this.handleNavigationMenu();
    },

    methods: {
        setupLoggedInClient(data) {
            this.loggedIn = data.logged_in_client;
            setUserId(data.user?.id);

            if (this.loggedIn) {
                setClientId(data.logged_in_client.id);
            }
        },

        setIsEventContext(route_name){
            this.is_event_context = route_name === 'event' || route_name === 'events' || route_name === 'events2';
        },

        setIsOnlineCourseContext(route_name) {
            this.is_online_course_context = ['online-courses', 'online-course', 'buy-online-course'].includes(route_name);
        },

        setIsMembershipsContext(route_name) {
            this.is_memberships_context = ['memberships', 'membership-plan', 'buy-membership-plan'].includes(route_name);
        },

        sendGAPageView(to) {
            if (to && typeof gtag === 'function') {

                gtag('config', window.ga4_measurement_id, {
                    'page_path': to.path
                });
                gtag('event', 'page_view');
            }
        },

        signMeOut() {
            this.$event_bus.$emit('signMeOut');
            this.loggedIn = null;
            location.reload();
        },

        signOutConfirm: function () {
            var vm = this;
            swal({
                title: trans('online_booking.logout'),
                text: trans('online_booking.logout_confirm'),
                showCancelButton: true,
                cancelButtonText: trans('global.cancel'),
                showLoaderOnConfirm: true,
                closeOnConfirm: false,
            }, function () {
                vm.loading = true;

                http.get('/book/' + vm.permalink + '/logout')
                    .then(({data}) => {
                        vm.$router.push('/book/' + vm.permalink);
                        location.reload();
                    })
                    .catch(({error, errorBag}) => {
                        vm.loading = false;
                    });

            });
        },

        getClientTimezoneOffset() {
            if (client_timezone == '') {
                return dayjs().utcOffset();
            }

            return dayjs().tz(client_timezone).utcOffset();
        },

        getPracticeTimezoneOffset() {
            return dayjs().tz(practice_timezone).utcOffset();
        },

        generateTheme() {
            const storedColor = this.themeColor;
            if (Color(storedColor).isValid()) {
                const element = document.querySelector(":root")
                const storedColorHSL = Color(storedColor).toHsl();
                element.style.setProperty("--brand-hue", storedColorHSL.h);
                element.style.setProperty("--brand-saturation", `${storedColorHSL.s * 100}%`);
                element.style.setProperty("--brand-lightness", `${storedColorHSL.l * 100}%`);
            }
        },

        handleNavigationMenu() {
            // if available_routes has only one route, hide the navigation menu
            this.hideNavigationMenu = window.available_routes.length === 1;
        },

    },

    computed: {
        ...mapGetters('OnlineBooking', ['currentStepNumber']),

        tzOffset() {
            return this.showTimezoneOffset ? client_timezone_offset_formatted : '';
        },

        hidePracticeInfo() {
            return ['events', 'events2', 'online-courses', 'memberships', 'online-course'].includes(this.$route.name);
        },
    },
    mixins: [
        currentRoute
    ],
}
</script>